import React, {Component} from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import ProjectBudgetBreakdownListItem from "./ProjectBudgetBreakdownListItem";
import ProjectBudgetBreakdownInput from "./ProjectBudgetBreakdownInput";

import removeProjectBudgetMutation from '../../queries/server/mutations/remove_project_budgets'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'
import ProjectBudgetInput from "./ProjectBudgetInput";
import ProjectLocationListItem from "./ProjectLocationsListItem";
import AddressLabel from "./address/AddressLabel";
import AddressLabelSimple from "./address/AddressLabelSimple";
import StageLabel from "./project/StageLabel";

class ProjectBudgetListItem extends Component {

    state = {
        showInput: false,
        editing: false
    }

    toggleInput = () => {
        this.setState({showInput: !this.state.showInput})
    }

    render() {

        const {props, state} = this

        return (
            <Mutation mutation={removeProjectBudgetMutation}>
                {(removeProjectBudgetMutationFunc, {loading}) => (
                    <div className="d-flex flex-column border-bottom mt-3 pb-3">

                        {state.editing && <ProjectBudgetInput
                            project_id={props.project_id}
                            id={props.id}
                            project_activity_type_id={props.project_activity_type_id}
                            description={props.description}
                            address_id={props.address_id}
                            stage={props.stage}
                            addresses={props.addresses}
                            onSaved={() => this.setState({editing: false})}
                            onCancel={() => this.setState({editing: false})}
                            successMessage="Budget Updated"
                        />}

                        {!state.editing && <div className="d-flex flex-row justify-content-between">
                            <div className="d-flex flex-column">
                                <h5>{props.project_activity_type.description} {props.description ? ` - ${props.description}` : ''}</h5>
                                {props.address && <AddressLabelSimple address={props.address.full_address}/>}
                                {props.stage && <StageLabel stage={props.stage}/>}
                            </div>


                            <div className="d-flex flex-row">

                                <Button
                                    size="sm"
                                    color="warning"
                                    onClick={() => this.setState({editing: true})}
                                    disabled={loading}
                                    className="mr-1 square-btn"
                                >
                                    <FontAwesomeIcon color="#fff" icon="edit"/>
                                </Button>

                                <Mutation mutation={editProjectLocalMutation}>
                                    {(editProjectLocalMutation) => (
                                        <Button
                                            size="sm"
                                            color="danger"
                                            onClick={() => {
                                                removeProjectBudgetMutationFunc({variables: {project_id: props.project_id, ids: [props.id]}})
                                                    .then(({data}) => {
                                                        editProjectLocalMutation({variables: {data: data.removeProjectBudgets}})
                                                        toast.success('Budget Removed', {autoClose: 2000})
                                                    })
                                                    .catch(e => toast.error(e.message, {autoClose: false}))
                                            }}
                                            disabled={loading}
                                            className="square-btn"
                                        >
                                            <FontAwesomeIcon color="#fff" icon="trash-alt"/>
                                            {loading && 'Removing...'}
                                        </Button>
                                    )}
                                </Mutation>
                            </div>


                        </div>}

                        {
                            props.breakdown.map(breakdown => <ProjectBudgetBreakdownListItem
                                parent_id={props.id}
                                project_id={props.project_id}
                                key={breakdown.id}
                                {...breakdown}
                            />)
                        }

                        {state.showInput && <div className="d-flex pb-2">
                            <ProjectBudgetBreakdownInput
                                project_id={props.project_id}
                                parent_id={props.id}
                                onCancel={() => this.setState({showInput: false})}
                                successMessage="Budget Breakdown Added"
                            />
                        </div>}


                        {!state.showInput && <Button
                            outline
                            size="sm"
                            color="success"
                            onClick={this.toggleInput}
                        >
                            <FontAwesomeIcon
                                icon="plus"
                                className="text-success"
                            />{' '}
                            Add Breakdown
                        </Button>}

                    </div>
                )}

            </Mutation>
        )
    }

}

ProjectBudgetListItem.propTypes = {
    id: PropTypes.number.isRequired,
    project_id: PropTypes.string.isRequired,
    project_activity_type_id: PropTypes.number.isRequired,
    project_activity_type: PropTypes.object.isRequired,
    description: PropTypes.string,
    address_id: PropTypes.number,
    address: PropTypes.object,
    stage: PropTypes.string,
    addresses: PropTypes.array,
}

export default ProjectBudgetListItem